export interface ICreateOrganizationCoupon {
  organizationId: number;
  couponTypeId: number;
  discountAmount: number;
  expirationDate?: string;
}

export enum ICouponType {
  GENERAL_COUPON = 1
}

export interface IOrganizationCoupon {
  id: number;
  organizationId: number;
  code: string;
  couponTypeId: number;
  discountAmount: number;
  expirationDate: string | null;
  usedAt: string | null;
  couponApplication: ICouponApplication;
}

export interface ICouponApplication {
  orderId?: number;
  logisticServiceId?: number;
}
